// Le Menu (touche ☰ de la barre du bas).
//
// ⚛️ ÉCRAN MIGRÉ VERS REACT → js/react/ecrans/Menu.jsx
// Ce fichier n'est plus qu'un adaptateur pour le routeur de app.js.
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Menu from "../react/ecrans/Menu.jsx";

export const rendre = vueReact(Menu);
